/**
 * Validates auto convert url patterns. The regex is matching:
 * - optional protocol (http://, https://)
 * - allows wildcard (*) subdomains
 * - requires a valid domain (no wildcards)
 * - requires a valid TLD (.com, .org, etc.)
 * - optional paths
 * - 1024 character limit
 * For more information: https://hello.atlassian.net/wiki/spaces/ECO/pages/4856894219/Manifest+Schema+Changes+Documentation
 */
export const isPatternValid = (pattern: string) => {
	const urlRegex =
		/^(?=.{1,1024}$)(?:https?:\/\/)?(?:[a-zA-Z0-9-\*]+\.)*(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(?:\/.*)?$/;

	return urlRegex.test(pattern);
};
